import { defineMessages } from 'react-intl';

export default defineMessages({
  errorOcurred: {
    id: 'global_trovitAds_backoffice_applies_updateError',
    defaultMessage: 'An error has occurred',
  },
  retry: {
    id: 'global_error_retry_btn',
    defaultMessage: 'Retry',
  },
});



// WEBPACK FOOTER //
// ./app/components/mobile/SnackError/messages.js